import Config from 'configs'

export default () => {
  const url = Config.ENVIRONMENT === 'dev' ? 'http://localhost:3000' : Config.WEB_BASE_URL
  const versionFile = url + '/version.json'
  return fetch(versionFile).then(response => response.json())
}
